module.exports = __webpack_public_path__ + "pc-top-assets/img/twitter.747f77b1.svg";